import React from "react";
import {useNavigate} from "react-router-dom";
import {useGlobalState} from "../../GlobalState";
import {trackEvent, TRACKING_EVENTS} from "../../util/TrackingHelper";
import LogoMedium from "../../images/Logo_Medium.webp";
import {STRINGS} from "../../constants/Strings";
import {BCIcon, ICONS} from "../generic/BCIcons";
import {BCPrimaryButton, BCTertiaryButton} from "../generic/BCButtons";
import {FlexRow} from "../generic/Containers";

export const LandingPagedHeader: React.FC<{ isEducator: boolean }> = ({isEducator}) => {
    const navigate = useNavigate()
    const { isAuthenticated, setShowAuthModal, setAuthModalMode, isPremium, setShowPremiumOverlay, setShowEducatorInquiryModal } = useGlobalState();

    const onHeaderLinkClicked = () => {
        trackEvent(TRACKING_EVENTS.PAGE_NAVIGATION, {
            content_id: "/"
        })
        navigate("/")
    }

    const handleAuthClick = (mode: 'login' | 'register') => {
        // Track which auth button was clicked
        if (mode === 'login') {
            trackEvent(TRACKING_EVENTS.LOGIN_CLICKED, {
                source: 'mobile_header'
            });
        } else {
            trackEvent(TRACKING_EVENTS.REGISTER_CLICKED, {
                source: 'mobile_header'
            });
        }

        setAuthModalMode(mode);
        setShowAuthModal(true);
    };

    return (
        <div className="dashboard-mobile-header-module-container">
            <div className={"header-module-content"}>
                <img className={"header-logo"} src={LogoMedium} alt={"Beyond Code Logo"} role="button" tabIndex={0} onClick={() => onHeaderLinkClicked()}/>
                {!isEducator ? (
                    <div className={'header-logged-out-buttons'}>
                        <div className={'header-logged-out-web-container'}>
                            <button className="log-in-button" onClick={() => handleAuthClick('login')}
                                    style={{fontWeight: '500'}}>LOG IN
                            </button>
                            <button className="register-button" onClick={() => handleAuthClick('register')}
                                    style={{fontWeight: '500'}}>JOIN FOR FREE
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className={'header-logged-out-buttons'}>
                        <div className={'header-logged-out-web-container'}>
                            <BCTertiaryButton className={'educator-header-cta'} text={STRINGS.EDUCATOR_PAGE_HEADER_CTA} onClick={() => navigate('/')} iconRight={ICONS.EXTERNAL_LINK} style={{fontWeight: '500'}}/>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}


export const LandingPagedHeaderV3: React.FC<{ isEducator: boolean }> = ({isEducator}) => {
    const navigate = useNavigate()
    const { isAuthenticated, setShowAuthModal, setAuthModalMode, isPremium, setShowPremiumOverlay, setShowEducatorInquiryModal } = useGlobalState();

    const onHeaderLinkClicked = () => {
        trackEvent(TRACKING_EVENTS.PAGE_NAVIGATION, {
            content_id: "/"
        })
        navigate("/")
    }

    const handleAuthClick = (mode: 'login' | 'register') => {
        // Track which auth button was clicked
        if (mode === 'login') {
            trackEvent(TRACKING_EVENTS.LOGIN_CLICKED, {
                source: 'mobile_header'
            });
        } else {
            trackEvent(TRACKING_EVENTS.REGISTER_CLICKED, {
                source: 'mobile_header'
            });
        }

        setAuthModalMode(mode);
        setShowAuthModal(true);
    };

    return (
        <div className="dashboard-mobile-header-module-container-v3">
                <img className={"header-logo landing-page-logo"} src={LogoMedium} alt={"Beyond Code Logo"} role="button" tabIndex={0} onClick={() => onHeaderLinkClicked()}/>
                <FlexRow>
                    <BCTertiaryButton className={"header-secondary-btn"} text={"Testimonials"} onClick={() => {}}/>
                    <BCTertiaryButton className={"header-secondary-btn"} text={"About"} onClick={() => {}}/>
                </FlexRow>
                <BCPrimaryButton
                    text={"JOIN FOR FREE"}
                    className={'dashboard-primary-cta header-btn'}
                    onClick={() => {
                        setAuthModalMode('register');
                        setShowAuthModal(true);
                    }}
                />
        </div>
    );
}
